package one.healthium.ui.common.lifecycle

import androidx.compose.runtime.Composable
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LifecycleStartEffect
import one.primehealth.app.AppLifecycleChannel
import org.koin.compose.koinInject

@Composable
fun AppLifecycleDispatcherEffect(key: Any, content: @Composable () -> Unit) {
    val appLifecycleChannel = koinInject<AppLifecycleChannel>()
    LifecycleStartEffect(key) {
        appLifecycleChannel.dispatchEvent(Lifecycle.Event.ON_START)

        onStopOrDispose {
            appLifecycleChannel.dispatchEvent(Lifecycle.Event.ON_STOP)
        }
    }
    content()
}